import { defineComponent, PropType } from "@vue/composition-api";
import { IlsctlLineItem } from "@/models/IlsctlLineItem";
import { itemRouteBuilder, NamedRts } from "@/router";

export default defineComponent({
  name: "ilsctlLineItemPartial",
  props: {
    lnItem: {
      type: Object as PropType<IlsctlLineItem>,
      required: true,
    },
  },

  setup(_props, _ctx) {
    const scShowRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.sellContractShow, id);
    };

    const ilShowRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.inventoryLotDetails, id);
    };

    return {
      scShowRouteBuilder,
      ilShowRouteBuilder,
    };
  },
});
